export default "__VITE_ASSET__CqRab0_4__"